
import Controller, { OnChange, OnClick, OnMount, OnReadSuccess } from '@philips-internal/oswald-ui-core/lib/client';
import { ChangePatientInformationAliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';
import { ChangeEvent, ReadEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { BarcodeAPI, BarcodeData, ButtonAPI, PanelAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import InformationBarUtils from '../commons/header/information-bar-header-utils';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';
import { Endpoint } from '../../constants/endpoints';
import { BrokerService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { changePatientData, ChangePatientData } from '../../interfaces/change-patient/change-patient-data';
import { DataContext } from '@philips-internal/oswald-ui-core/lib/component';
import { ToastMsgUtils } from '../../utils/toastmsg-utils';

let textDepartment: any;
@Controller({ component: ChangePatientInformationAliases.LAYOUT_MAIN_CHANGE_LOCATION, fragment: FragmentNames.CHANGE_PATIENT_INFORMATION })
class PatientInformationController extends BaseController {
  @Inject(ChangePatientInformationAliases.BUTTON_CONFIRM)
  private readonly buttonConfirm!: ButtonAPI;

  @Inject(ChangePatientInformationAliases.PANEL_MODAL)
  private readonly panelLoaderApi!: PanelAPI;

  @OnChange({ target: ChangePatientInformationAliases.FIELD_DEPARTMENTS })
  onFieldChange(event: ChangeEvent<string>): void {
    const { value } = event;
    if (!value) {
      this.buttonConfirm.setVisible(false);
      return;
    }
    this.buttonConfirm.setVisible(true);
    textDepartment = { value };
  }

  @OnClick({ target: ChangePatientInformationAliases.BUTTON_CANCEL })
  onClickCancel(): void {
    applicationContext.popNavigationItem();
  }

  @OnClick({ target: ChangePatientInformationAliases.BUTTON_CONFIRM })
  async onClickConfirm(): Promise<void> {
    const unidade = textDepartment.value.cdBarras;
    const nrSequencia = textDepartment.value.nrSequencia;
    try {
      const resp = await HttpService.get(Endpoint.GET_UNITS_AVAILIABLE, {
        unitId: unidade,
      });
      const body = resp.body as { dsLocal: string; nrSequencia: string }[];
      let index = 0;
      body.forEach((element) => {
        if (element.nrSequencia === nrSequencia) {
          index = body.indexOf(element);
        }
      });
      const data = body[index] as ChangePatientData;
      const route = ApplicationRoute.CHANGE_PATIENT_CONFIRMATION;
      changePatientData.isPatientDisplacement = false;
      applicationContext.redirect(route);
      BrokerService.subscribeToTopic(
        'setChangeData',
        (context: DataContext) => { context.set({ changeData: data }); }
      );
    } catch (error) {
      ToastMsgUtils.toastErrorMessage('tws.error-generic', 'text.contact_system_admin');
    }
  }

  @OnMount({target: ChangePatientInformationAliases.LAYOUT_MAIN_CHANGE_LOCATION})
  onMountInput(): void {
    this.mountInformationBar();
  }

  @OnReadSuccess({target: ChangePatientInformationAliases.BARCODE_COMPONENT_LOCAL_PA})
  async onReadSuccessBarcode(event: ReadEvent<BarcodeData>): Promise<void> {
    const barcode = event.target as BarcodeAPI;
    if (barcode) {
      barcode.setEnabled(false);
      this.panelLoaderApi.setVisible(true);
      const procParams = {
        unitId: event.item.value.trim(),
      };
      try {
        const resp = await HttpService.get(
          Endpoint.GET_UNITS_AVAILIABLE,
          procParams
        );
        const isValidResponse =
          Array.isArray(resp.body) && resp.body.length > 0;
        if (isValidResponse) {
          const body = resp.body as { dsLocal: string; nrSequencia: string }[];
          const data = body[0] as ChangePatientData;
          const route = ApplicationRoute.CHANGE_PATIENT_CONFIRMATION;
          applicationContext.redirect(route);
          BrokerService.subscribeToTopic(
            'setChangeData',
            (context: DataContext) => {
              context.set({ changeData: data });
            }
          );
          this.panelLoaderApi.setVisible(false);
        } else {
          ToastMsgUtils.toastErrorMessage('text.message-alert-attention', 'text.attendance_unit_not_found');
          this.panelLoaderApi.setVisible(false);
          barcode.setEnabled(true);
        }
      } catch (err) {
        ToastMsgUtils.toastErrorMessage('tws.error-generic', 'text.contact_system_admin');
        this.panelLoaderApi.setVisible(false);
        barcode.setEnabled(true);
      }
    }
  }

  private mountInformationBar(): void {
    const { patientId, encounterId } =
      this.historyService.getCurrentRouteParams();
    InformationBarUtils.collapsedBar = true;
    InformationBarUtils.allowInfo = true;

    this.context.set({
      encounterId,
      patientId,
    });
  }
}

export default PatientInformationController;
